
export enum ProtocolCategory {
    PARTNER,
    NFT
}